import { MapPin, Monitor } from 'lucide-react';
import { useCampaignScreensQuery } from '@/features/campaigns/api/campaignDetailApi';
import { fmtCurrency, fmtDate } from '../campaignDetailPage.utils';
import { Empty, Loading, MiniStat } from '../CampaignDetailPagePrimitives';

export function ScreensTab({ campaignId, startDate, endDate, role }: { campaignId?: string; startDate?: string; endDate?: string, role: string }) {
  const q = useCampaignScreensQuery(campaignId);
  const billboards = q.data?.data?.billboards || [];
  const currency = q.data?.data?.pricing?.currency || 'INR';
  // const {user} = useAuth();


  if (q.isPending) return <Loading />;

  if (!billboards.length) return <Empty text="No screens found for this campaign." />;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {billboards.map((b, i) => (
        <div
          key={i}
          className="group rounded-2xl border border-[var(--dash-line)] bg-white p-5 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
        >
          <div className="mb-3 flex items-center gap-2.5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[var(--dash-brand-soft)] text-[var(--dash-brand)]">
              <Monitor className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <h3 className="m-0 truncate text-[13px] font-semibold text-[var(--dash-ink)]">
                {b.screenName}
              </h3>
              {b.screenType ? (
                <span className="text-[10px] font-semibold text-[var(--dash-muted)]">
                  {b.screenType}
                </span>
              ) : null}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2">
            {role !== 'CLIENT' ? (
              <MiniStat label="Price" value={fmtCurrency(b.totalPrice, currency)} />
            ) : null}
            <MiniStat label="Date" value={startDate && endDate ? `${fmtDate(startDate)} to ${fmtDate(endDate)}` : '—'} />
            <MiniStat label="Time Slots" value={b.totalSlots} />
            <MiniStat label="Plays" value={b.assignedRepetitions} />
          </div>

          {b.address?.fullAddress ? (
            <p className="m-0 mt-3 flex items-start gap-1.5 text-[11px] leading-relaxed text-[var(--dash-muted)]">
              <MapPin className="mt-0.5 h-3 w-3 shrink-0 text-[var(--dash-brand)]" />
              {b.address.fullAddress}
            </p>
          ) : null}
        </div>
      ))}
    </div>
  );
}
